// extracted by mini-css-extract-plugin
export var active = "_4j-2";
export var highlight = "_4j-1";
export var highlightLayer = "_4j-0";
export var issuePopover = "_4j-3";
export var statusIcon = "_4j-4";